<template>
  <rest-list-column v-bind="columnProps(metric, index)" :sortable="sortable" />
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import { restMetricGroupLabels } from '@/common/enum/RestMetricGroupEnum'
import _ from 'lodash'

export default {
  name: 'RestMetricColumn',

  components: { RestListColumn },

  props: {
    metric: {
      required: true
    },

    index: {
      required: true
    },

    metricGroup: {
      type: Object,
      required: true
    },

    prop: {
      type: String,
      required: true
    },

    align: {
      type: String
    },

    width: {
      type: Number
    },

    customProps: {
      type: Object,
      default: () => ({})
    },
    sortable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      restMetricGroupLabels
    }
  },

  computed: {
    columnAlign() {
      return this.align ? this.align : 'center'
    },

    columnWidth() {
      return this.width ? this.width : 200
    }
  },

  methods: {
    generateLabel(metricName) {
      return this.restMetricGroupLabels[metricName]
        ? this.$t(this.restMetricGroupLabels[metricName])
        : metricName
    },

    columnProps(metric, index) {
      let rowKey =
        this.metricGroup.name + '.' + this.metricGroup.metrics[index].name

      let props = {
        title: this.generateLabel(metric.name),
        width: this.columnWidth,
        prop: this.prop + '.metrics[' + index + ']',
        filterInput: false,
        isGroup: true,
        propIsMetric: true,
        sortable: true,
        sortField: rowKey
      }

      props = _.merge(
        props,
        this.customProps['default'],
        this.customProps[rowKey]
      )

      return props
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestMetricColumn.vue